import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/images/logo.png";

export default function Header() {
    const [scrolled, setScrolled] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const toggleBtnRef = useRef(null);
    const closeBtnRef = useRef(null);


    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 8);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);


    useEffect(() => {
        document.body.classList.toggle("menu-open", menuOpen);
        return () => document.body.classList.remove("menu-open");
    }, [menuOpen]);


    useEffect(() => {
        if (menuOpen) {
            closeBtnRef.current && closeBtnRef.current.focus();
        } else {
            toggleBtnRef.current && toggleBtnRef.current.focus();
        }
    }, [menuOpen]);


    useEffect(() => {
        const onKeyDown = (e) => {
            if (e.key === "Escape" && menuOpen) setMenuOpen(false);
        };
        document.addEventListener("keydown", onKeyDown);
        return () => document.removeEventListener("keydown", onKeyDown);
    }, [menuOpen]);


    useEffect(() => {
        const onResize = () => {
            if (window.innerWidth > 860 && menuOpen) setMenuOpen(false);
        };
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, [menuOpen]);

    const closeMenu = () => setMenuOpen(false);

    return (
        <>
            <header className={`header-root${scrolled ? " header-scrolled" : ""}`}>
                <nav className="header-nav wrap" style={{ paddingLeft: 0, paddingRight: 0 }}>
                    <a href="/" className="logo">
                        <img src={logo} alt="Global Innovation" style={{ width: "70px", height: "auto" }} />
                    </a>

                    <div className="header-nav-links">
                        <a href="/">Home</a>
                        <a href="/about">About Us</a>
                        <a href="/#how-it-works">How It Works</a>                    </div>

                    <div className="header-nav-actions">
                        <Link to="/login" className="btn-global btn-primary-global" style={{ fontSize: "12px", background: "#000080", color: "#fff !important" }}>
                            Log In
                        </Link>
                        <Link to="/register" className="btn-global btn-primary-global" style={{ fontSize: "12px" }} onClick={closeMenu}>
                            Register
                        </Link>
                        <button
                            type="button"
                            className="header-nav-toggle"
                            ref={toggleBtnRef}
                            aria-expanded={menuOpen}
                            aria-controls="mobileMenu"
                            aria-label="Open menu"
                            onClick={() => setMenuOpen((open) => !open)}
                        >
                            <span className="header-bars">
                                <span></span>
                                <span></span>
                                <span></span>
                            </span>
                        </button>
                    </div>
                </nav>
            </header>

            <div
                className={`header-menu-backdrop${menuOpen ? " header-open" : ""}`}
                onClick={closeMenu}
            ></div>

            <nav
                className={`header-mobile-menu${menuOpen ? " header-open" : ""}`}
                id="mobileMenu"
                aria-label="Mobile"
                aria-hidden={!menuOpen}
            >
                <div className="header-mobile-menu-head">
                    <a href="/" className="logo">
                        <span className="logo-mark"></span>Global Innovation
                    </a>
                    <button
                        type="button"
                        className="header-mobile-menu-close"
                        ref={closeBtnRef}
                        aria-label="Close menu"
                        onClick={closeMenu}
                    >
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M18 6L6 18M6 6l12 12" />
                        </svg>
                    </button>
                </div>

                <div className="header-mobile-menu-links">
                    <a href="/" onClick={closeMenu}>Home</a>
                    <a href="/about" onClick={closeMenu}>About</a>
                    <a href="/#how-it-works" onClick={closeMenu}>
                        How it works
                    </a>

                </div>

                <div className="header-mobile-menu-actions">
                    <Link
                        to="/login"
                        className="login"
                        onClick={closeMenu}
                    >
                        Log in
                    </Link>
                    <Link to="/register" className="btn-global btn-primary-global" onClick={closeMenu}>
                        Register
                    </Link>
                </div>
            </nav>
        </>
    );
}